import React from "react";

interface IconIProps {
  size?: string;
}

const PdfIcon = ({ size = "24" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6045 2.25001H7.27875C7.1613 2.24971 7.04494 2.2726 6.93634 2.31737C6.82775 2.36213 6.72906 2.4279 6.64594 2.51088C6.56282 2.59387 6.49689 2.69244 6.45194 2.80096C6.40699 2.90948 6.3839 3.0258 6.384 3.14325V7.125L14.6858 9.5625L22.5 7.125V3.14325C22.5001 3.02573 22.477 2.90935 22.432 2.80079C22.387 2.69222 22.321 2.59361 22.2378 2.51061C22.1546 2.42762 22.0558 2.36187 21.9471 2.31715C21.8385 2.27243 21.722 2.24961 21.6045 2.25001Z"
        fill="#EE4144"
      />
      <path
        d="M22.5 7.125H6.384V12L14.6858 13.4625L22.5 12V7.125Z"
        fill="#D32B2E"
      />
      <path
        d="M6.384 12V16.875L14.1975 17.85L22.5 16.875V12H6.384Z"
        fill="#BD181B"
      />
      <path
        d="M7.27875 21.75H21.6038C21.7213 21.7505 21.8379 21.7277 21.9466 21.6831C22.0554 21.6384 22.1543 21.5727 22.2375 21.4897C22.3208 21.4067 22.3869 21.308 22.4319 21.1994C22.477 21.0908 22.5001 20.9743 22.5 20.8567V16.875H6.384V20.8567C6.3839 20.9742 6.40699 21.0905 6.45194 21.199C6.49689 21.3076 6.56282 21.4061 6.64594 21.4891C6.72906 21.5721 6.82775 21.6379 6.93634 21.6826C7.04494 21.7274 7.1613 21.7503 7.27875 21.75Z"
        fill="#911012"
      />
      <path
        opacity="0.1"
        d="M19.3255 6.1499H6.38278V18.3374H19.3255C19.5623 18.3362 19.789 18.2418 19.9567 18.0746C20.1243 17.9074 20.2193 17.6809 20.221 17.4442V7.04315C20.2193 6.80641 20.1243 6.57989 19.9567 6.4127C19.789 6.2455 19.5623 6.15108 19.3255 6.1499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M18.8373 6.63745H6.38309V18.825H18.8373C19.074 18.8238 19.3008 18.7294 19.4684 18.5622C19.636 18.395 19.731 18.1684 19.7328 17.9317V7.5307C19.731 7.29396 19.636 7.06744 19.4684 6.90024C19.3008 6.73305 19.074 6.63863 18.8373 6.63745Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M18.8373 6.63745H6.37892V17.85H18.8373C19.074 17.8488 19.3008 17.7544 19.4684 17.5872C19.636 17.42 19.731 17.1934 19.7328 16.9567V7.5307C19.731 7.29396 19.636 7.06744 19.4684 6.90024C19.3008 6.73305 19.074 6.63863 18.8373 6.63745Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M18.349 6.63745H6.38089V17.85H18.349C18.5858 17.8488 18.8125 17.7544 18.9802 17.5872C19.1478 17.42 19.2428 17.1934 19.2445 16.9567V7.5307C19.2428 7.29396 19.1478 7.06744 18.9802 6.90024C18.8125 6.73305 18.5858 6.63863 18.349 6.63745Z"
        fill="black"
      />
      <path
        d="M18.3486 6.63746C18.5858 6.63726 18.8135 6.73168 18.9814 6.89917C19.1493 7.06666 19.2437 7.2939 19.2441 7.53101V16.4695C19.2437 16.7066 19.1493 16.9339 18.9814 17.1013C18.8135 17.2687 18.5857 17.3623 18.3486 17.3621H2.39551C2.27799 17.3625 2.16141 17.3404 2.05273 17.2957C1.94406 17.2509 1.84492 17.1853 1.76172 17.1023C1.67852 17.0193 1.61335 16.9198 1.56836 16.8113C1.52346 16.7029 1.49994 16.5868 1.5 16.4695V7.53101C1.4999 7.41349 1.52336 7.2968 1.56836 7.18824C1.6133 7.07986 1.67869 6.9811 1.76172 6.8982C1.84487 6.81525 1.94413 6.74956 2.05273 6.70484C2.16141 6.66012 2.27799 6.63706 2.39551 6.63746H18.3486Z"
        fill="url(#paint0_linear_2814_6313)"
      />
      <path
        d="M5.72266 12.9727H4.27344V12.0586H5.72266C5.94661 12.0586 6.12891 12.0221 6.26953 11.9492C6.41016 11.8737 6.51302 11.7695 6.57812 11.6367C6.64323 11.5039 6.67578 11.3542 6.67578 11.1875C6.67578 11.0182 6.64323 10.8607 6.57812 10.7148C6.51302 10.569 6.41016 10.4518 6.26953 10.3633C6.12891 10.2747 5.94661 10.2305 5.72266 10.2305H4.67969V15H3.50781V9.3125H5.72266C6.16797 9.3125 6.54948 9.39323 6.86719 9.55469C7.1875 9.71354 7.43229 9.93359 7.60156 10.2148C7.77083 10.4961 7.85547 10.8177 7.85547 11.1797C7.85547 11.5469 7.77083 11.8646 7.60156 12.1328C7.43229 12.401 7.1875 12.6081 6.86719 12.7539C6.54948 12.8997 6.16797 12.9727 5.72266 12.9727Z"
        fill="white"
      />
      <path
        d="M10.4102 15H9.17188L9.17969 14.0859H10.4102C10.7174 14.0859 10.9766 14.0169 11.1875 13.8789C11.3984 13.7383 11.5573 13.5339 11.6641 13.2656C11.7734 12.9974 11.8281 12.6732 11.8281 12.293V12.0156C11.8281 11.724 11.7969 11.4674 11.7344 11.2461C11.6745 11.0247 11.5846 10.8385 11.4648 10.6875C11.3451 10.5365 11.1979 10.4232 11.0234 10.3477C10.849 10.2695 10.6484 10.2305 10.4219 10.2305H9.14844V9.3125H10.4219C10.8021 9.3125 11.1497 9.3776 11.4648 9.50781C11.7826 9.63542 12.0573 9.81901 12.2891 10.0586C12.5208 10.2982 12.6992 10.5846 12.8242 10.918C12.9518 11.2487 13.0156 11.6172 13.0156 12.0234V12.293C13.0156 12.6966 12.9518 13.0651 12.8242 13.3984C12.6992 13.7318 12.5208 14.0182 12.2891 14.2578C12.0599 14.4948 11.7852 14.6784 11.4648 14.8086C11.1471 14.9362 10.7956 15 10.4102 15ZM9.83594 9.3125V15H8.66406V9.3125H9.83594Z"
        fill="white"
      />
      <path
        d="M15.0391 9.3125V15H13.8672V9.3125H15.0391ZM17.3047 11.7422V12.6562H14.7188V11.7422H17.3047ZM17.5781 9.3125V10.2305H14.7188V9.3125H17.5781Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2814_6313"
          x1="4.58906"
          y1="5.93548"
          x2="9.62747"
          y2="20.3463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C42326" />
          <stop offset="0.5" stopColor="#BE1A1D" />
          <stop offset="1" stopColor="#AC1114" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default PdfIcon;
